import { Component, OnInit } from '@angular/core';
import { SpacesService } from '../services/spaces.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-space',
  templateUrl: './space.component.html',
  styleUrls: ['./space.component.scss']
})
export class SpaceComponent implements OnInit {
  public space;
  constructor(
    private spacesService: SpacesService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.space = this.spacesService.getSpace(params.id);
      console.log(this.space);
      if (!this.space) {
        this.router.navigate(['/pagenotfound']);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/space/space.component.ts